import { useCallback } from 'react';
import { useAssistantLayout, selectIsOpen } from './useAssistantLayout';
import { publishAsk, publishFocusInput, publishOpenChatList, publishOpenConversation, publishStartNew } from '../magpie/academyAssistantChannel';

/** Per-turn options for {@link UseAcademyAssistant.ask}. */

/**
 * The single control surface for the Academy Assistant, usable from any React
 * root on the page. Layout reads/writes go through the persisted
 * `useAssistantLayout` store; the imperative intents (`ask`,
 * `openConversation`, `startNew`, `focusInput`) are published over the
 * same-window Magpie channel for the assistant host to act on. Video context
 * is set separately via `useAcademyAssistantContext` / the context-store
 * module fns.
 */
export const useAcademyAssistant = () => {
  const mode = useAssistantLayout(state => state.mode);
  const open = useAssistantLayout(state => state.open);
  const close = useAssistantLayout(state => state.close);
  const toggleMode = useAssistantLayout(state => state.toggleMode);
  const ask = useCallback((text, options) => publishAsk(text, options), []);
  const openChatList = useCallback(options => publishOpenChatList(options), []);
  const openConversation = useCallback(conversationId => publishOpenConversation(conversationId), []);
  const startNew = useCallback(() => publishStartNew(), []);
  const focusInput = useCallback(() => publishFocusInput(), []);
  return {
    mode,
    isOpen: selectIsOpen(mode),
    open,
    close,
    toggleMode,
    ask,
    openChatList,
    openConversation,
    startNew,
    focusInput
  };
};